/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { IconsInterface } from "components/icons";
import Image from "components/ui/Image";
import cn from "utils/cn";

import { useEventThemeLogos } from "hooks/useEventThemeLogos";

const Logo = ({ className }: IconsInterface) => {
  const { logo, isLoading } = useEventThemeLogos();
  return (
    <div test-id="YVOaiApd">
      <Image
        src={logo}
        alt="logo"
        className={cn(className, isLoading && "invisible")}
        test-id="TuuEWQjr"
      />
    </div>
  );
};

export default Logo;
